import HistoryDetails from "./HistoryDetail";

export default HistoryDetails;
